export const USER_TYPES = {
  USER: 1,
  COMPANY_ADMIN: 2,
  COMPANY_OWNER: 3
} as const;

export const ROUTES = {
  AUTH: {
    USER: {
      LOGIN: '/auth/user/login',
      PASSWORD: '/auth/user/password'
    },
    COMPANY: {
      LOGIN: '/auth/company/login',
      PASSWORD: '/auth/company/password',
      CONFIRM_EMAIL: '/auth/company/confirm-email',
      CODE_SENT: '/auth/company/code-sent'
    }
  },
  DASHBOARD: {
    USER: '/dashboard/user',
    COMPANY: '/dashboard/company'
  }
} as const;

export const STORAGE_KEYS = {
  USER_DATA: 'userData',
  COMPANY_USER_DATA: 'companyUserData'
} as const;

export const TOAST_MESSAGES = {
  LOGIN_SUCCESS: 'Acceso autorizado',
  LOGOUT_SUCCESS: 'Sesión cerrada',
  EMAIL_REQUIRED: 'Por favor ingrese un email válido',
  USER_NOT_FOUND: 'El correo ingresado no está registrado en el sistema.',
  UNAUTHORIZED_ACCESS: 'No tiene permisos para acceder a esta sección',
  CONNECTION_ERROR: 'Error de conexión'
} as const;